import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { OFFICIAL_NODE_BTC_AMOUNT } from '@/constants';

// 使用插件
dayjs.extend(utc);
dayjs.extend(timezone);

const getLocalTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const formatTimestamp = (timestamp: number): string => {
  const timezone = getLocalTimezone(); // 自动获取本机时区
  return dayjs.unix(timestamp).tz(timezone).format('YYYY-MM-DD HH:mm:ss');
};

export const formatToPercentage = (
  decimal: number | string,
  decimalPlaces = 2
) => {
  const value = Number(decimal);

  // 将小数转换为百分数
  const percentage = (value * 100).toFixed(decimalPlaces);
  return `${percentage}%`;
};

export const formatNumber = (num: number) => {
  return new Intl.NumberFormat().format(num);
};

export const address2Desensitize = (address: string | undefined, len: number = 2) => {
  if (!address) return address;
  const reg = new RegExp(`(\\w{${len}})\\w*(\\w{${len}})`);
  return address.replace(reg, '$1...$2');
};

/**
 * Official-node BTC display is keyed off the validator list `is_offical` flag.
 */
export const isOfficialNode = (node?: { is_offical?: boolean } | null) =>
  Boolean(node?.is_offical);

export const getOfficialBtcAmount = (isOfficial?: boolean) =>
  isOfficial ? OFFICIAL_NODE_BTC_AMOUNT : 0;

export const sumOfficialBtcAmount = (
  nodes?: Array<{ is_offical?: boolean }> | null
) =>
  (nodes ?? []).reduce(
    (total, node) => total + getOfficialBtcAmount(node?.is_offical),
    0
  );
